import { FC, Ref } from 'react'

import { Box } from '@factorialco/deprecated-design-system'
import { EmployeeCustomTablesSchemaFragment } from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import CustomTable from './_CustomTable'

interface Props {
  schemas: EmployeeCustomTablesSchemaFragment[]
  attachableId: string
  schemaRefs: Ref<HTMLElement>[]
  currency: string
  canManage: boolean
  canAddValues: boolean
}

const ListComponent: FC<Props> = ({
  schemas,
  attachableId,
  schemaRefs,
  currency,
  canManage,
  canAddValues,
}) => (
  <>
    {schemas.map((schema, key) => {
      if (schema.fields.length === 0) return null

      return (
        <Box key={key} ref={schemaRefs[key]} paddingTop="s16" paddingBottom="s80">
          <CustomTable
            key={`schema-table-${key}`}
            schema={schema}
            attachableId={attachableId}
            currency={currency}
            canManage={canManage}
            canAddValues={canAddValues}
          />
        </Box>
      )
    })}
  </>
)

export default observer(ListComponent)
